module.exports = __webpack_public_path__ + "img/sdg_icon_05.9cdd9d82.png";